/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplyingProgram,
    ApplyingProgramFromJSON,
    ApplyingProgramFromJSONTyped,
    ApplyingProgramToJSON,
} from './ApplyingProgram';

/**
 * 
 * @export
 * @interface GetApplyingProgramResponse
 */
export interface GetApplyingProgramResponse {
    /**
     * 
     * @type {number}
     * @memberof GetApplyingProgramResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetApplyingProgramResponse
     */
    message: string;
    /**
     * 
     * @type {ApplyingProgram}
     * @memberof GetApplyingProgramResponse
     */
    data: ApplyingProgram | null;
}

export function GetApplyingProgramResponseFromJSON(json: any): GetApplyingProgramResponse {
    return GetApplyingProgramResponseFromJSONTyped(json, false);
}

export function GetApplyingProgramResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetApplyingProgramResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ApplyingProgramFromJSON(json['data']),
    };
}

export function GetApplyingProgramResponseToJSON(value?: GetApplyingProgramResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ApplyingProgramToJSON(value.data),
    };
}

